import React, { Fragment } from "react";
import { useForm } from "react-hook-form";
import updateAction from "./updateAction";
import Button from "../../../../components/ui/button";
import { Title,NextButton } from "./free-consultation-steps.style";
import { Col } from "../../../../components/ui/wrapper";
import { useStateMachine } from "little-state-machine";
import { ErrorStepSection } from './ErrorStepsSection';

const StepThree = ({ count, setCount }) => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const { actions } = useStateMachine({updateAction});
  
    const onSubmit = (data) => {
      if (data.work) {
        actions.updateAction(data);
        setCount(count + 1);
      }
    };
  
    const onPreviousState = () => {
      setCount(count - 2);
    };
  
    return (
      <Fragment>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Title>You work</Title>
          <label htmlFor="company">For a Company</label>
          <input
            style={{ margin: "0px 25px 0px 5px" }}
            {...register('work')}
            type="radio"
            value="company" />
          <label htmlFor="account">To your Account</label>{" "}
          <input
            style={{ margin: "0px 25px 0px 5px" }}
            {...register('work')}
            type="radio"
            value="account"
            checked />
          <ErrorStepSection 
            field="company" 
            errors={errors} 
            errorMessage={errors?.company?.message}
            stepNumber={3}
          />  
          <Col lg={12}>
            <Button 
              mt="30px" 
              skin="dark"
              onClick={(e) => onPreviousState()}
            >
              Back
            </Button>
            <NextButton 
              type="submit"
              hover={3}
              skin='secondary'
            >
              Next
            </NextButton>
          </Col>
        </form>
      </Fragment>
    );
  };

  export {StepThree}